// extracted by mini-css-extract-plugin
export default {"contactLink":"TabContentStudent__contactLink__Gwl4k"};